import { Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreItemCategory } from '@flecto/types'
import { type DataTableColumn } from '@flecto/ui'

import { CellActions } from './CellActions'
import { CellCategoryGroup } from './CellCategoryGroup'

export const useColumns = () => {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_inventory' })

  const columns: DataTableColumn<CoreItemCategory>[] = [
    {
      accessor: 'id',
      render: (row) => <Text c='dimmed'>#{row.id}</Text>,
      title: 'ID',
      width: 70,
    },
    {
      accessor: 'group_category',
      render: (row) => <CellCategoryGroup item={row} />,
      title: t('table.group_category'),
      width: 450,
    },
    {
      accessor: 'products',
      render: (row) => <Text>{row.items_count}</Text>,
      title: t('table.products'),
      width: 120,
    },
    {
      accessor: 'actions',
      render: (row) => <CellActions item={row} />,
      title: '',
    },
  ]
  return columns
}
